import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { Observable } from 'rxjs';

import { AccountService } from 'app/core';
import { QueryConfig } from 'app/core/models';
import { Account } from 'app/core/models/account.types';
import { AlertBannerComponent } from '../widgets/alert-banner/alert-banner.component';
import { RelatedToType } from 'app/shared/enums';
import { Dictionary } from 'app/shared/models';

@Component({
  selector: 'app-tags-panel',
  templateUrl: './tags-panel.component.html',
  styleUrls: ['./tags-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, AlertBannerComponent, MatDividerModule, MatProgressSpinnerModule],
})
export class TagsPanelComponent implements OnInit {
  private account: Account;
  private selectedTags: string[] = [];
  private _queryFilters: QueryConfig.QueryFilters;

  public tags$: Observable<Dictionary<number>>;
  public tagsError$: Observable<HttpErrorResponse>;

  get queryFilters(): QueryConfig.QueryFilters {
    return this._queryFilters;
  }

  @Input() set queryFilters(filters: QueryConfig.QueryFilters) {
    this._queryFilters = filters;
    if (this.selectedTags) this.selectedTags = this.queryFilters?.tags;
  }

  @Input() relatedToType: RelatedToType;

  @Output() tagsUpdated: EventEmitter<string[]>;

  constructor(private readonly _accountService: AccountService) {
    this.tagsUpdated = new EventEmitter();
    this.account = this._accountService.getCurrentAccount();
  }

  ngOnInit(): void {
    this.getTags();
  }

  private getTags(): void {
    this.tagsError$ = this._accountService.accountTagsError$;
    this.tags$ = this._accountService.getAccountTags(this.relatedToType);
  }

  public isTagListResponseEmpty(obj: { [key: string]: number }): boolean {
    return Object.keys(obj).length === 0;
  }

  public toggleSelectedTag(tag: string): void {
    if (this.selectedTags?.includes(tag)) this.selectedTags = this.selectedTags.filter((item) => item !== tag);
    else this.selectedTags.push(tag);
    this.tagsUpdated.emit(this.selectedTags);
  }

  public isTagSelected(tag: string): boolean {
    if (!this.selectedTags) this.selectedTags = [];
    return this.selectedTags?.includes(tag);
  }
}
